<!-- {{tipo}} {{cardTipo}} -->
<!-- <div>tipo: {{ tipo }}, componente atual: {{ componenteAtual }}</div> -->

<h3>
  <a
    *ngIf="tipo === 'vigentes' || tipo === 'curso' || cardTipo === 'mudouNome'"
    class="link"
    tabindex="0"
    routerLink="/cursos/curso"
    [queryParams]="{ id: itemId }"
  >
    {{ titulo }}
    <span *ngIf="cardTipo === 'mudouNome'"> > {{ cursoAtual }}</span>
  </a>
  <a
    class="link"
    tabindex="0"
    routerLink="/eixo-tecnologico"
    *ngIf="tipo === 'eixo'"
    [queryParams]="{ id: itemId }"
    >{{ titulo }}
  </a>
</h3>

<!-- Teste OK -->
<h4
  *ngIf="(tipo === 'faq' || tipo === 'legislacao') && componenteAtual === 'faq'"
  tabindex="0"
>
  <button
    title="Titulo"
    class="toggle-collapsed"
    type="button"
    [attr.aria-expanded]="collapsed[indice]"
    [attr.aria-controls]="indice"
    (click)="toggleCollapse(indice)"
  >
    <i class="fas fa-chevron-down fa-lg" *ngIf="!collapsed[indice]"></i>
    <i class="fas fa-chevron-up fa-lg" *ngIf="collapsed[indice]"></i>
  </button>
  {{ titulo }}
</h4>

<!--  -->
<div
  *ngIf="tipo === 'faq' && componenteAtual === 'faq'"
  class="collapse"
  [id]="indice"
  [class.show]="collapsed[indice]"
>
  <p [innerHTML]="texto | textToLink | format3"></p>
</div>

<!-- pesquisa-->
<h3
  *ngIf="
    (tipo === 'faq' || tipo === 'legislacao') && componenteAtual === 'pesquisa'
  "
  tabindex="0"
>
  <!-- {{ titulo }} -->
  <a
    href="{{ link }}"
    target="_blank"
    rel="noreferrer"
    class="link custom-link"
    >{{ titulo }}</a
  >
</h3>

<div *ngIf="cardTipo === 'excluido'">
  <h3 class="title-sem-link">
    {{ titulo }}
  </h3>

  <p tabindex="0">Eixo tecnológico: {{ eixoNome | removeEixo }}</p>
</div>

<!-- TEXTO TEXTO TEXTO -->
<p tabindex="0" *ngIf="tipo === 'curso' || tipo === 'vigentes'">
  {{ texto | removeAsteristicoUnderline | shorten }}
</p>

<!-- <p *ngIf="tipo === 'legislacao'" tabindex="0">
   {{ texto | removeAsteristicoUnderline | textToLink }}
</p> -->

<!-- <div class="collapse" [id]="'marca' + indice">
  <p *ngIf="tipo === 'faq'" [innerHTML]="texto | removeAsteristicoUnderline | textToLink">
  </p>
</div> -->

<!-- Botão de tipo faq e legislação, oriundo de pesquisa -->
<div
  *ngIf="
    (tipo === 'faq' || tipo === 'legislacao') && componenteAtual === 'pesquisa'
  "
>
  <p
    [innerHTML]="
      encurtarTexto
        ? (texto | textToLink | shorten : 144)
        : (texto | textToLink)
    "
  ></p>
  <br />
  <button
    *ngIf="texto && displayBtn(texto)"
    (click)="encurtarTexto = !encurtarTexto"
    class="br-button secondary small"
    type="button"
    role="button"
  >
    {{ encurtarTexto ? 'Ver mais' : 'Ver menos' }}
  </button>
</div>

<!-- Botão de tipo faq e legislação, oriundo de pesquisa -->
<span tabindex="0" class="br-tag small" [ngClass]="bgColor" *ngIf="cursoMsg">{{
  cursoMsg
}}</span>

<hr class="hr-line bg-color-dark-grey" />
